export default __webpack_public_path__ + "static/media/loading.ecd6929a.gif";